<template>
  <div class="home" :class="">
    <h1><router-link to="/">Sorry, we can't find what you're looking for.</router-link></h1>
  </div>
</template>

<script>

  export default {
    name: 'PageNotFound',
    data : function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/js/pages/PageNotFound.vue